import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=a2d7882e&"
import script from "./SiteConfig.vue?vue&type=script&lang=js&"
export * from "./SiteConfig.vue?vue&type=script&lang=js&"
import style0 from "./SiteConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports